module.exports = __webpack_public_path__ + "static/media/creative-instagram-grid-layouts.14e59f84.png";